import React from "react";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faParking } from "@fortawesome/pro-solid-svg-icons";

const ParkingNote = ({ kiosk, parkingNote, onGotoEditParkingNote, t }) => {
  if (!kiosk.show_parking_location_note_on_kiosk_check_in) return null;

  return (
    <div className="OrderParkingNote" onClick={onGotoEditParkingNote}>
      <div className="OrderParkingNote__Header">
        <FontAwesomeIcon icon={faParking} />

        <h4 className="icon-text">{t("kiosk_parking_location_note").message || "Parking Location Note"}</h4>
        {parkingNote ? (
          <div className="OrderParkingNote__Text" dangerouslySetInnerHTML={{ __html: parkingNote.replace(/\n/g, "<br />") }} />
        ) : (
          <h4 className="placeholder">{t("kiosk_enter_your_parking_location").message || "Enter your parking location"}</h4>
        )}
      </div>
    </div>
  );
};

export default withTranslation()(ParkingNote);
